<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
  <div *ngIf="!$.row.restricted_to_eligible_clients && !$.row.restricted_to_eligible_service_products_category && !$.row.restricted_to_eligible_plan_products_category && !$.row.restricted_to_eligible_organisations; else restricted">
    {{'ADMIN.COUPON.NOT_RESTRICTED' | translate}}
  </div>
  <ng-template #restricted>
    <span class="cursor-pointer text-primary" *ngIf="$.row.restricted_to_eligible_clients" (click)="GetClients($.row)">
      {{ $.row.client_restricted == 1 ? ('ADMIN.COUPON.CLIENT_COUNT' | translate : {count:$.row.client_restricted} ): ('ADMIN.COUPON.CLIENTS_COUNT' | translate : {count:$.row.client_restricted} ) }}
    </span>
    <br *ngIf="$.row.restricted_to_eligible_clients">
  <span class="cursor-pointer text-primary" *ngIf="$.row.restricted_to_eligible_service_products_category" (click)="addServices($.row)">
    {{ $.row.service_restricted == 1 ? ('ADMIN.COUPON.PRODUCT_COUNT' | translate : {count:$.row.service_restricted} ): ('ADMIN.COUPON.PRODUCTS_COUNT' | translate : {count:$.row.service_restricted} ) }}
  </span>
  <br *ngIf="$.row.restricted_to_eligible_service_products_category">
  <span class="cursor-pointer text-primary" *ngIf="$.row.restricted_to_eligible_plan_products_category" (click)="addPlans($.row)">
    {{ $.row.plan_restricted == 1 ? ('ADMIN.COUPON.PLAN_COUNT' | translate : {count:$.row.plan_restricted} ): ('ADMIN.COUPON.PLANS_COUNT' | translate : {count:$.row.plan_restricted} ) }}
  </span>
  <br *ngIf="$.row.restricted_to_eligible_plan_products_category">
  <span class="cursor-pointer text-primary" *ngIf="$.row.restricted_to_eligible_organisations" (click)="addOrganization($.row)">
    {{ $.row.organization_restricted == 1 ? ('ADMIN.COUPON.ORGANIZATION_COUNT' | translate : {count:$.row.organization_restricted} ): ('ADMIN.COUPON.ORGANIZATION_COUNTS' | translate : {count:$.row.organization_restricted} ) }}
  </span>
  </ng-template>
</ng-container>

<coupon-eligible-clients *ngIf="(addClientsModal | async) as show" [tenantId]="tenantId" [couponMaster]="couponMaster"
  [visible]="show" (closeEvent)="closeEvent($event)">
</coupon-eligible-clients>

<app-coupon-service-restriction *ngIf="(addServicessModal | async) as show" [tenantId]="tenantId"
  [couponMaster]="couponMaster" [visible]="show" (closeEvent)="closeEvent($event)" [serviceIds]="selectedServiceIds">
</app-coupon-service-restriction>

<coupon-plan-restriction *ngIf="(addPlansModal | async) as show" [tenantId]="tenantId"
  [couponMaster]="couponMaster" [visible]="show" (closeEvent)="closeEvent($event)" [planIds]="selectedPlanIds">
</coupon-plan-restriction>

<coupon-organization-restriction *ngIf="(addOrganisationModal | async) as show" [tenantId]="tenantId"
  [couponMaster]="couponMaster" [visible]="show" (closeEvent)="closeEvent($event)" [organizationIds]="selectedOrganizationIds">
</coupon-organization-restriction>

